/** 客户池 */
export default{
    name: 'customerpool',
    path: 'customerpool',
    meta: { title: '客户池' },
    component: ()=>import('@/pages/index.vue'),
    children: [
        {
            name: 'customerpool-index',
            path: 'index',
            meta: { title: '客户池' },
            component: ()=>import('@/pages/customerpool/index.vue')
        },
        {
            name: 'customerpool-retainage',
            path: 'retainage',
            meta: { title: '尾款待付' },
            component: ()=>import('@/pages/customerpool/retainage.vue')
        },
        {
            name: 'customerpool-index',
            path: 'info',
            meta: { title: '客户资料' },
            component: ()=>import('@/pages/customerpool/info.vue')
        }
    ]
}
